import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.227 3.5a.72.72 0 0 0-.727.713.72.72 0 0 0 .727.714.72.72 0 0 0 .727-.714.72.72 0 0 0-.727-.713M2 4.213A2.22 2.22 0 0 1 4.227 2a2.22 2.22 0 0 1 2.227 2.213 2.22 2.22 0 0 1-2.227 2.214A2.22 2.22 0 0 1 2 4.213m0 7.805c0-2.845 2.326-5.14 5.18-5.14h8.862c2.855 0 5.181 2.295 5.181 5.14 0 2.846-2.326 5.14-5.18 5.14H7.18C4.326 17.159 2 14.865 2 12.019m5.18-3.64c-2.039 0-3.68 1.636-3.68 3.64s1.641 3.64 3.68 3.64h3.682v-7.28zm5.182 0v7.28h3.68c2.04 0 3.681-1.636 3.681-3.64s-1.641-3.64-3.68-3.64zm6.634 10.732a.72.72 0 0 0-.727.713.72.72 0 0 0 .727.714.72.72 0 0 0 .727-.714.72.72 0 0 0-.727-.713m-2.227.713a2.22 2.22 0 0 1 2.227-2.213 2.22 2.22 0 0 1 2.227 2.213 2.22 2.22 0 0 1-2.227 2.214 2.22 2.22 0 0 1-2.227-2.214",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }